import { convertIntif } from "@project/sharedcomponents/utilityFunctions"
import { EMAIL_TEMPLATE_SERVICE_START, EMAIL_TEMPLATE_SERVICE_SUCCESS, EMAIL_TEMPLATE_SERVICE_UPDATED } from "../Actions/types"

const INITIAL_STATE = {
  loading: false,
  data: [],
  norecord: false,
  columnData: [
    { id: "template_title", numeric: false, visible: true, label: "Title", width: 150 },
    { id: "template_subject", numeric: false, visible: true, label: "Subject" },
  ],
}
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EMAIL_TEMPLATE_SERVICE_START:
      return { ...state, loading: true }
    case EMAIL_TEMPLATE_SERVICE_SUCCESS:
      return { ...state, data: action.payload.data.result, norecord: action.payload.data.result.length === 0 }
    case EMAIL_TEMPLATE_SERVICE_UPDATED:
      let updateddata = state.data.map((item, index) => {
        if (convertIntif(item.code) !== convertIntif(action.payload.update_code)) {
          return item
        }
        const updateditem = { ...item }
        updateditem.template_title = action.payload.title
        updateditem.template_subject = action.payload.subject
        return updateditem
      })
      return { ...state, data: updateddata }
    default:
      return state
  }
}
